import type { IInitCustomer } from "../types/api/customer";

/** customer 스토어 공통 초기 데이터 */
export const initCustomer: IInitCustomer = {
  token: {
    accessToken: "",
    expiresAt: "",
  },
  customer: {
    acceptsMarketing: false,
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    phone: "",
    tags: [],
    metafields: [],
    addresses: {
      edges: [],
      nodes: [],
      pageInfo: {
        endCursor: undefined,
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: undefined,
      },
    },
    numberOfOrders: "",
    createdAt: "",
    displayName: "",
    orders: {
      edges: [],
      nodes: [],
      pageInfo: {
        endCursor: undefined,
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: undefined,
      },
      totalCount: "",
    },
    gender: undefined,
    birth: undefined,
    wishlist: undefined,
    updatedAt: "",
  },
  countryCode: "",
  loginCallback: null,
};
